import React from 'react'
import { useInView } from 'react-intersection-observer'

const Child = ({height = 300, children}) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
    })
    const style = {
        ...(!inView && {height})
    }
    return (
        <div style={style} ref={ref}>
            {inView ? children : ""}
        </div>
    );
}

const LazyLoader = ({
    children
}) => (
    <React.Fragment>
        {
            React.Children.map(children, child => {
                return <Child>{child}</Child>
            })
        }
    </React.Fragment>
);

export default LazyLoader
